// BarChart.jsx
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ barChartData }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,   // <-- REQUIRED
    resizeObserver: true,         // <-- IMPORTANT FIX
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Student Loan Distribution" },
    },
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%", // chart fills the parent
        minHeight: "280px", // ensure visible
      }}
    >
      <Bar data={barChartData} options={options} />
    </div>
  );
};

export default BarChart;
